
import React from "react";

export default function Mission() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-[#0066CC]/10 rounded-full text-[#0066CC] text-sm font-medium mb-6">
              Our Mission
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Mission Statement
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Patriot Defense Technologies exists to protect the
              organizations that keep our country strong. Guided by the values of military
              service, discipline, and integrity, we deliver security-first IT and
              cybersecurity solutions that safeguard small businesses, defend the defense
              supply chain, and ensure the reliable operation of critical systems. Our
              mission is to reduce cyber risk, strengthen compliance, and provide trusted,
              mission-focused technology services that allow our clients to operate with
              confidence.
            </p>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="w-full h-[400px] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/3bb4ba4b36ba435028d980e53e70c45b.jpg"
                alt="Cybersecurity operations protecting critical systems"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#0066CC]/10 rounded-2xl -z-10"></div>
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-[#C41E3A]/10 rounded-xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
